
<template>
  <el-dialog :title="selectedItemId === null ? '新增人員' : '編輯人員'" :visible.sync="innerVisible">
      <el-form :model="form" ref="form" :rules="rules">

      <!--<el-form-item label="所屬單位" :label-width="formLabelWidth" >-->
        <!--<el-input :value="myownOrg" readonly autocomplete="off"></el-input>-->
      <!--</el-form-item>-->
      <el-form-item label="人員名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="人員編號" :label-width="formLabelWidth" prop="no">
        <el-input v-model="form.no" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="班級名稱" :label-width="formLabelWidth" prop="className">
        <el-input v-model="form.className" autocomplete="off"></el-input>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item label="月光機序號" :label-width="formLabelWidth" prop="moonlight2SerialNumber">
        <el-input v-model="form.moonlight2SerialNumber" autocomplete="off"></el-input>
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item
        label="綁定澈見幸福App"
        :label-width="formLabelWidth"
        prop="isLinkLuciditvApp">
          <el-switch
            v-model="form.isLinkLuciditvApp"
            active-text="是"
            inactive-text="否"></el-switch>
      </el-form-item>

      <el-form-item label="註冊電話國碼" :label-width="formLabelWidth" prop="phoneArea">
        <el-input v-model="form.phoneArea" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="註冊電話號碼" :label-width="formLabelWidth" prop="phoneNumber">
        <el-input v-model="form.phoneNumber" autocomplete="off"></el-input>
      </el-form-item>

      <el-divider></el-divider>
      <el-form-item
        label="錄音上傳是否降噪"
        :label-width="formLabelWidth"
        prop="isDenoise">
          <el-switch
            v-model="form.isDenoise"
            active-text="是"
            inactive-text="否"></el-switch>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item label="備註" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.memo"></el-input>
      </el-form-item>

      </el-form>

      <template #footer class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">確 定</el-button>
      </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { SYS_ORG_NAME } from '@/appConfig';
export default {
  model: {
    prop: 'visible',
    event: 'toggleVisible',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectedItemId: {
      type: Number,
      default: null,
    }
  },
  computed: {
    isMyownOrgSys() {
      return this.myownOrg === SYS_ORG_NAME
    },
    adminTitle() {
      return this.isMyownOrgSys ? '超級管理員' : '單位管理員';
    },
    ...mapGetters({
      myownOrg: 'auth/orgName',
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('toggleVisible', val);
      }
    }
  },
  data() {
    return {
      rules: {
        //no: [
          //{ required: true, message: '請輸入人員編號', trigger: 'blur' },
        //],
        name: [
          { required: true, message: '請輸入人員名稱', trigger: 'blur' },
        ],
        //className: [
          //{ required: true, message: '請輸入班級名稱', trigger: 'blur' },
        //],
      },
      formLabelWidth: '130px',
      form: {
        no: '',
        name: '',
        className: '',
        moonlight2SerialNumber: null,
        isLinkLuciditvApp: false,
        phoneArea: null,
        phoneNumber: null,
        memo: '',
        isDenoise: false,
      },
    }
  },
  created () {
    if(this.innerVisible) {
      if (this.selectedItemId !== null) {
        const data = this.$store.getters['member/getMemberById'](this.selectedItemId);
        this.form.id=data.id;
        this.form.no=data.no;
        this.form.name=data.name;
        this.form.className=data.className;
        this.form.moonlight2SerialNumber=data.moonlight2SerialNumber;
        this.form.isLinkLuciditvApp=data.isLinkLuciditvApp;
        this.form.phoneArea=data.phoneArea;
        this.form.phoneNumber=data.phoneNumber;
        this.form.memo=data.memo;
        this.form.isDenoise=data.isDenoise;
      }
    }
  },
  methods: {
    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
            if(this.selectedItemId !== null) {
              this.submitUpdate();
            } else {
              this.submitAdd();
            }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      this.$store.dispatch('member/add', this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch('member/list', null);
      })
    },
    submitUpdate() {
      this.$store.dispatch('member/update', this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch('member/list', null);
      })
    },
  }
}
</script>

<style>
</style>
